// import React from "react";
import { useNavigate } from "react-router-dom";

export default function OfferProduct() {
  const router = useNavigate();
  return (
    <section className="has-offer">
      <div className="container">
        <h2 className="fw-bold">Explore more products Fusion has to offer</h2>

        <div className="mt-5 mb-2 d-flex justify-content-center align-items-center gap-3 flex-wrap">
          <div
            data-aos="flip-left"
            onClick={() => router("/pos-system")}
            className="scey-fhj mb-2"
          >
            <div className="box-d mb-2">
              <img
                loading="lazy"
                src="/assets/img/landing/Point of Sale.svg"
                alt="fusion"
                className=""
              />
            </div>
            <p>Point of Sale</p>
          </div>
          <div
            data-aos="flip-left"
            onClick={() => router("/pos-system")}
            className="scey-fhj mb-2"
          >
            <div className="box-d mb-2">
              <img
                loading="lazy"
                src="/assets/img/landing/Fusion Connect.svg"
                alt="fusion"
                className=""
              />
            </div>
            <p>Fusion Connect</p>
          </div>
          <div
            data-aos="flip-left"
            onClick={() => router("/self-serve-kiosks")}
            className="scey-fhj mb-2"
          >
            <div className="box-d mb-2">
              <img
                loading="lazy"
                src="/assets/img/landing/Kiosk.svg"
                alt="fusion"
                className=""
              />
            </div>
            <p>Kiosk</p>
          </div>
          <div
            data-aos="flip-left"
            onClick={() => router("/payments/proPay")}
            className="scey-fhj mb-2"
          >
            <div className="box-d mb-2">
              <img
                loading="lazy"
                src="/assets/img/landing/Card Readers.svg"
                alt="fusion"
                className=""
              />
            </div>
            <p>Card Readers</p>
          </div>
          <div
            data-aos="flip-left"
            onClick={() => router("/business-account")}
            className="scey-fhj mb-2"
          >
            <div className="box-d mb-2">
              <img
                loading="lazy"
                src="/assets/img/landing/Business.svg"
                alt="fusion"
                className=""
              />
            </div>
            <p>Business Account</p>
          </div>
          <div
            data-aos="flip-left"
            onClick={() => router("/online-ordering")}
            className="scey-fhj mb-2"
          >
            <div className="box-d mb-2">
              <img
                loading="lazy"
                src="/assets/img/landing/Online Ordering.svg"
                alt="fusion"
                className=""
              />
            </div>
            <p>Online Ordering</p>
          </div>
        </div>
      </div>
    </section>
  );
}
